// extracted by mini-css-extract-plugin
export default {"content":"VerifyEmailPage_content__8K+os","headline":"VerifyEmailPage_headline__Pk4NE"};